<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                结费任务
                <small>结费任务</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 结费任务
                    </a>
                </li>
                <li class="active">结费任务</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <div class="col-sm-12">
                <div id="atptoolbar">
                    <!--                    <button class="btn btn-success" type="button" id="sys_add" @click="addtask">-->
                    <!--                        <i class="fa fa-primary"></i>&nbsp;添加-->
                    <!--                    </button>-->
                    <!--                    <button class="btn btn-warning" type="button" id="sys_dispatch" @click="dispatch">-->
                    <!--                        <i class="fa fa-pencil"></i>&nbsp;修改-->
                    <!--                    </button>-->
                    <!--                    <button class="btn btn-danger" type="button" id="sys_del" @click="deltask">-->
                    <!--                        <i class="fa fa-pencil"></i>&nbsp;删除-->
                    <!--                    </button>-->
                </div>
                <table id="paytask_atptable"></table>
            </div>
        </section>
        <!-- /.content -->
        <v-advancesearch></v-advancesearch>
        <v-addpayTask ref="addpayTask"></v-addpayTask>
        <v-ammeterdispatch :info-taskid="task_id" ref="ammeterdispatch"></v-ammeterdispatch>
    </div>
</template>

<script>
  import advancesearch from './advancedsearch'
  import addPayTask from './addpayTask'
  import ammeterdispatch from './ammeterdispatch'

  export default {
    name: 'payTasklist',
    data () {
      return {
        stationid: '', // 基站id
        task_id: ''
      }
    },
    components: {
      'v-advancesearch': advancesearch,
      'v-addpayTask': addPayTask,
      'v-ammeterdispatch': ammeterdispatch
    },
    mounted: function () {
      // 获取所有的结费任务
      var self = this
      $('#paytask_atptable').bootstrapTable({
        url: self.global.apiHost + 'pay_tasks/',
        method: 'get', // 请求方式（*）
        ajaxOptions: {
          headers: {
            'content-type': 'application/json', // 默认值
            Authorization: 'Bearer ' + localStorage.getItem('access_token')
          }
        },
        toolbar: '#atptoolbar', // 工具按钮用哪个容器
        height: $(window).height() * 0.86,
        striped: true, // 是否显示行间隔色
        cache: false, // 是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
        pagination: true, // 是否显示分页（*）
        iconSize: 'outline',
        sortable: true, // 是否启用排序
        sortName: 'can_pay_time',
        sortOrder: 'DESC', // 排序方式
        queryParams: self.queryParams, // 传递参数（*）
        sidePagination: 'server', // 分页方式：client客户端分页，server服务端分页（*）
        pageNumber: 1, // 初始化加载第一页，默认第一页
        pageSize: 10, // 每页的记录行数（*）
        pageList: [10], // 可供选择的每页的行数（*）
        // search: true, // 是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
        showColumns: true, // 是否显示所有的列
        showRefresh: true, // 是否显示刷新按钮
        minimumCountColumns: 2, // 最少允许的列数
        clickToSelect: true, // 是否启用点击选中行
        singleSelect: true, // 是否启用单选
        uniqueId: 'id', // 每一行的唯一标识，一般为主键列
        responseHandler: function (res) {
          console.log('-------', res)
          return {
            total: res.total, // 总页数
            rows: res.rows // 数据
          }
        },
        columns: [
          [
            { checkbox: true },
            {
              title: '序号',
              width: 40,
              formatter: function (value, row, index) {
                var option = $('#paytask_atptable').bootstrapTable('getOptions')
                return option.pageSize * (option.pageNumber - 1) + index + 1
              }
            },
            {
              title: '创建时间',
              width: 40,
              field: 'create_time'
            },
            {
              title: '基站名称',
              width: 40,
              field: 'stst_commname'
            },
            {
              title: '运营商',
              width: 40,
              field: 'stst_comm'
            },
            {
              title: '结费类型',
              width: 40,
              field: 'type',
              formatter: function (value, row, index) {
                const typeDict = {
                  1: '业主租金',
                  2: '局方地租金',
                  3: '局方杆租金',
                  4: '业务协调费',
                  5: '平台签约奖励',
                  6: '杆塔资源费',
                  7: '商务提成'
                }
                return typeDict[value] || '未知类型'
              }
            },
            {
              title: '应结费金额',
              width: 40,
              field: 'money'
            },
            {
              title: '可结费时间',
              width: 40,
              field: 'can_pay_time'
            },
            {
              title: '实际结费时间',
              width: 40,
              field: 'pay_at'
            },
            {
              title: '备注',
              width: 40,
              field: 'remakr'
            },
          ]
        ]
      })
    },
    methods: {
      queryParams: function (param) {
        console.log()
        param.org_id = JSON.parse(localStorage.getItem('companyInfo')).id
        param.per_page = param.limit
        param.page = param.offset / param.limit + 1
        return param
      },
      // 打开添加结费任务页面
      // addtask: function () {
      //   var self = this
      //   $('#sys_addtask_modal').modal('show')
      //   setTimeout(function () {
      //     self.$refs.addpayTask.initFunc() // 调用子组件函数
      //   }, 1000)
      // },
      // 派单
      // dispatch: function () {
      //   var self = this
      //   var tablerow = $('#paytask_atptable').bootstrapTable('getSelections')
      //   if (tablerow.length == 1) {
      //     var _task_id = tablerow[0].id
      //     self.task_id = _task_id
      //     $('#sys_ammeterdispatch_modal').modal('show')
      //     setTimeout(function () {
      //       self.$refs.ammeterdispatch.initFunc() // 调用子组件函数
      //     }, 1000)
      //   } else {
      //     alert('必须只选择一项')
      //   }
      // },
      // 删除结费任务
      // deltask: function () {
      //   var self = this
      //   var tablerow = $('#paytask_atptable').bootstrapTable('getSelections')
      //   if (tablerow.length === 1) {
      //     // confirm
      //     var r = confirm('确定删除该结费任务?') // 询问框里的文字描述
      //     if (r == true) {
      //       var _task_id = tablerow[0].id
      //       self.global.axiosDelete(
      //         self,
      //         'tasks/' + _task_id + '/',
      //         function (res) {
      //           if (res.status === 'success') {
      //             alert('删除成功')
      //           } else {
      //             alert('操作失败')
      //           }
      //           $('#paytask_atptable').bootstrapTable('refresh')
      //         },
      //         function (res) {
      //           alert('操作失败')
      //         }
      //       )
      //     } else {
      //       console.log('取消')
      //     }
      //   } else {
      //     alert('必须只选择一项')
      //   }
      // }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/payTask/payTaskList.vue